import type { ApiSupplier } from '@/fetcher'

type SupplierListPageProps = {
  suppliers: ApiSupplier[]
  isLoading: boolean
  selectedSupplierId: string
  canManage: boolean
  onSelect: (supplierId: string) => void
  onEdit: (supplier: ApiSupplier) => void
}

export const SupplierListPage = ({
  suppliers,
  isLoading,
  selectedSupplierId,
  canManage,
  onSelect,
  onEdit,
}: SupplierListPageProps) => {
  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <h1 className="text-lg font-semibold tracking-tight text-[var(--app-text)]">
          Выберите поставщика
        </h1>
      </div>

      {isLoading ? (
        <div className="rounded-[22px] bg-[var(--app-card)] px-4 py-6 text-center text-sm text-[var(--app-muted)]">
          Загрузка поставщиков...
        </div>
      ) : suppliers.length === 0 ? (
        <div className="rounded-[22px] bg-[var(--app-card)] px-4 py-6 text-center text-sm text-[var(--app-muted)]">
          Поставщики не добавлены
        </div>
      ) : (
        <ul className="space-y-2">
          {suppliers.map((supplier) => {
            const isSelected = supplier.id === selectedSupplierId
            return (
              <li key={supplier.id}>
                <div
                  className={`flex items-center justify-between gap-3 rounded-[18px] px-4 py-3 transition ${
                    isSelected
                      ? 'bg-[var(--app-accent-soft)]'
                      : 'bg-[var(--app-card)]'
                  }`}
                >
                  <button
                    type="button"
                    className="flex-1 min-w-0 text-left"
                    onClick={() => onSelect(supplier.id)}
                  >
                    <span className="block truncate text-sm font-medium text-[var(--app-text)]">
                      {supplier.name}
                    </span>
                    {supplier.description ? (
                      <span className="mt-0.5 block truncate text-xs text-[var(--app-muted)]">
                        {supplier.description}
                      </span>
                    ) : null}
                  </button>

                  {canManage ? (
                    <button
                      type="button"
                      className="shrink-0 rounded-full px-2 py-1 text-md font-medium text-[var(--app-muted)] transition hover:text-[var(--app-accent)]"
                      onClick={() => onEdit(supplier)}
                      aria-label="Редактировать поставщика"
                    >
                      ✎
                    </button>
                  ) : null}
                </div>
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}
